module.exports = __webpack_public_path__ + "static/media/blog_3.05597584.jpg";